import { render, staticRenderFns } from "./PaymentPagesList.vue?vue&type=template&id=8189e7aa&scoped=true"
import script from "./PaymentPagesList.vue?vue&type=script&lang=js"
export * from "./PaymentPagesList.vue?vue&type=script&lang=js"
import style0 from "./PaymentPagesList.vue?vue&type=style&index=0&id=8189e7aa&prod&scoped=true&lang=css"
import style1 from "./PaymentPagesList.vue?vue&type=style&index=1&id=8189e7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8189e7aa",
  null
  
)

export default component.exports